export const getUsername = (
  firstName: string | undefined | null,
  lastName: string | undefined | null,
  email: string | undefined | null,
) => {
  if (firstName && lastName) return `${firstName} ${lastName}`
  if (!email) return firstName || ''
  else return email || ''
}
